module.exports = __webpack_public_path__ + "img/profile.92a2ab42.svg";